<script lang="ts">
  import EntityMeta from '$shared/atoms/EntityMeta/EntityMeta.svelte';

  interface Props {
    metaData?: ObjectType<string> | null;
    monitoringMeta?: ObjectType<string> | null;
    hasProvidedInfoMeta?: boolean;
  }

  let { metaData = null, monitoringMeta = null, hasProvidedInfoMeta = false }: Props = $props();

  let hasMeta = $derived(Object.keys(metaData || {}).length !== 0);
  let hasMonitorMeta = $derived(Object.keys(monitoringMeta || {}).length !== 0);
</script>

{#if hasMeta || hasMonitorMeta}
  <div class="entity-meta">
    <div class="meta" class:no-margin={hasProvidedInfoMeta}>
      <EntityMeta meta={metaData} showIcon monitorConfig={monitoringMeta} />
    </div>
  </div>
{/if}

<style>
  .meta {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }
  .meta.no-margin {
    margin: unset;
  }
</style>
